var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.alarm.status_message)?_c('p',{staticClass:"mb-5"},[_c('i',[_vm._v(_vm._s(_vm.alarm.status_message))])]):_vm._e(),_c('p',{staticClass:"has-text-weight-bold"},[_vm._v("Affected devices:")]),_c('ul',{staticClass:"ml-4"},_vm._l((_vm.alarm.health),function(device){return _c('li',{key:device.serial},[_c('router-link',{attrs:{"to":{
          name: 'go-to-device',
          params: {
            serial: device.serial || device.gateway_serial,
          },
        }}},[_c('b',[_vm._v(_vm._s(device.serial || device.gateway_serial))])]),_vm._v(" : "+_vm._s(device.message)+" ")],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }